import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonDeathplaceCrumbs } from 'civil-status/constants/place';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformResponse } from 'civil-status/utils/place';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import FormPlace from 'civil-status/components/place/form';

const DeathplaceDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [deathplaceData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/luogo-codificato/${DomainType.Deathplace}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = deathplaceData.data as PlaceForm;

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonDeathplaceCrumbs, { name: 'Visualizza luogo decesso' }]} />
      {deathplaceData.isLoading || deathplaceData.pristine || deathplaceData.error ? undefined : (
        <FormPlace title="Visualizza luogo decesso" disabled initialValues={values} isDeath />
      )}
    </Fragment>
  );
};

DeathplaceDetailPage.displayName = 'Deathplace detail page component';

export default DeathplaceDetailPage;
